<template>
    <ThePage class="container">
        <template v-slot:title>
            Модемы
            <a target="_blank" :href="getKBLink('modems')" class="btn btn-link text-nowrap ml-2 px-0"><i class="tlm-icon-question-circle" /></a>
        </template>

        <div class="mb-3 d-none d-lg-block">
            <div class="d-flex justify-content-between">
                <span class="font-weight-bold">Регистрация нового модема</span>
                <button type="button" class="btn btn-outline-primary text-center" @click="isHelpVisible = true"><i class="tlm-icon-question-circle" /></button>
            </div>
        </div>

        <div class="card mb-4 d-none d-lg-block">
            <div class="card-body card-body-search">
                <ValidationObserver ref="obs" v-slot="{ invalid }" tag="form" class="form" @submit.prevent="submit">
                    <ValidationProvider v-errors.api tag="div" vid="identity" class="form-group mb-0" rules="required|numeric|min:15|max:16">
                        <div class="d-flex">
                            <input v-model="form.identity" v-focus type="text" class="form-control" placeholder="IMEI модема">
                            <button :disabled="invalid" class="btn btn-lg-192 btn-primary ml-3" type="submit">Зарегистрировать</button>
                        </div>
                    </ValidationProvider>
                </ValidationObserver>
            </div>
        </div>

        <div class="mb-4 d-block d-lg-none">
            <div class="d-flex flex-column flex-lg-row">
                <div class="mb-3 d-flex flex-row justify-content-between align-items-center">
                    <span class="font-weight-bold">Регистрация нового</span>
                    <button type="button" class="btn btn-outline-primary" @click="isHelpVisible = true">
                        <i class="tlm-icon-info-circle" />
                    </button>
                </div>

                <button type="button" class="btn btn-lg btn-primary" @click="isFormVisible = true">Новый модем</button>
            </div>
        </div>

        <template v-if="challenges && challenges.length > 0">
            <div class="mb-3">
                <div class="font-weight-bold mb-2">
                    Ожидают регистрации
                </div>

                <div class="text-muted d-none d-lg-block">
                    Для подтверждения физического владения устройством, вам необходимо <a :href="getKBLink('add_modem')" target="_blank">выполнить инструкцию</a>.
                </div>
            </div>

            <div class="card mb-4">
                <div class="card-body">
                    <table class="table table-striped table-hover">
                        <thead>
                            <tr>
                                <th style="width: 250px">Идентификатор</th>
                                <th>Время на регистрацию</th>
                                <th style="width: 50px" />
                            </tr>
                        </thead>

                        <transition-group tag="tbody" name="list">
                            <tr v-for="challenge in challenges" :key="challenge.id">
                                <td>{{ challenge.identity }}</td>
                                <td class="text-success">{{ challenge.expire_at | timeago }}</td>
                                <td>
                                    <button type="button" class="btn btn-icon btn-remove" @click="deleteChallenge(challenge.id)" />
                                </td>
                            </tr>
                        </transition-group>
                    </table>
                </div>
            </div>
        </template>

        <div class="font-weight-bold mb-3">
            Зарегистрированные модемы
        </div>

        <div class="card mb-3 d-none d-lg-block">
            <div class="card-body card-body-search">
                <input :value="filter.search" type="text" class="form-control form-control-search" placeholder="Быстрый поиск" @input="search">
            </div>
        </div>

        <div class="card">
            <div class="card-body">
                <table class="table table-striped table-hover">
                    <thead>
                        <tr>
                            <th v-sort:identity style="width: 250px">Идентификатор</th>
                            <th class="d-none d-lg-table-cell">Установлен</th>
                            <th class="d-none d-lg-table-cell text-nowrap">Последняя связь</th>
                            <th style="width: 50px" />
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="modem in modems" :key="modem.id">
                            <td>{{ modem.identity }}</td>
                            <td class="d-none d-lg-table-cell">
                                <router-link v-if="modem.vm_id" :to="{ name: 'vm', params: { id: modem.vm_id } }">T{{ modem.vm_id }}</router-link>
                                <span v-else class="text-muted">–</span>
                            </td>
                            <td class="d-none d-lg-table-cell">
                                <template v-if="modem.last_active_at">{{ modem.last_active_at | timeago }}</template>
                                <template v-else>
                                    <span class="text-muted font-italic">не выходил</span>
                                </template>
                            </td>
                            <td>
                                <button type="button" class="btn btn-icon btn-remove" @click="deleteModem(modem.id)" />
                            </td>
                        </tr>
                    </tbody>

                    <tfoot v-if="noOne" class="no-one">
                        <tr>
                            <td colspan="42">Вы пока не добавили ни одного модема.</td>
                        </tr>
                    </tfoot>

                    <tfoot v-if="noFound" class="no-one">
                        <tr>
                            <td colspan="42">По вашему запросу не найдено ни одного модема.</td>
                        </tr>
                    </tfoot>

                    <tfoot v-if="meta.last_page > 1">
                        <tr>
                            <td colspan="42">
                                <pagination :meta="meta" @input="applyFilter({ page: $event })" />
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>

        <TheModal v-if="isFormVisible" class="sm nofh" @close="isFormVisible = false">
            <template v-slot:head>Регистрация модема</template>

            <ValidationObserver ref="obs" v-slot="{ invalid }" tag="form" class="form" @submit.prevent="submit">
                <ValidationProvider v-errors.api tag="div" vid="identity" class="form-group mb-3" rules="required|numeric|min:15|max:16">
                    <input v-model="form.identity" type="text" class="form-control" placeholder="IMEI модема">
                </ValidationProvider>

                <button :disabled="invalid" class="btn btn-lg-192 btn-primary" type="submit">Зарегистрировать</button>
            </ValidationObserver>
        </TheModal>

        <TheModal v-if="isHelpVisible" class="sm" @close="isHelpVisible = false">
            <template v-slot:head>Инструкция</template>

            <p>Чтобы получать данные с модема, его сначала необходимо зарегистрировать.</p>
            <p>В форме <strong>Регистрация нового модема</strong> введите IMEI модема (он указан на лицевой панели устройства). Нажмите кнопку <strong>Зарегистрировать.</strong></p>
            <p>Чтобы подтвердить физическое владение устройством, необходимо в течение 24 часов выполнить <a target="_blank" :href="getKBLink('add_modem')">следующие действия</a></p>
            <p>Как только модем выйдет на связь, он будет зарегистрирован в системе, и после этого его можно будет привязать к какому-либо автомату.</p>
        </TheModal>
    </ThePage>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { mixinApiErrors } from '@/validation'

import Pagination from '@/components/Pagination'
import ThePage from '@/components/ThePage'
import TheModal from '@/components/TheModal'

import debounce from 'lodash/debounce'
import store from '@/store'
import { toastSuccess, toastError, confirm } from '@/dialogs'

import KBLinksService from '@/services/KBLinksService'

export default {
    components: {
        Pagination,
        ThePage,
        TheModal,
        ValidationProvider,
        ValidationObserver
    },

    props: {
        filter: {
            type: Object,
            default: _ => ({ })
        }
    },

    data() {
        return {
            isFormVisible: false,
            isHelpVisible: false,

            form: {
                identity: ''
            }
        }
    },

    computed: {
        isMobile() {
            return this.$store.state.isMobile
        },

        modems() {
            return this.$store.state.modems.data || []
        },

        meta() {
            return this.$store.state.modems.meta || {}
        },

        challenges() {
            return this.$store.state.modemsChallenges.data || []
        },

        noOne() {
            return !this.modems.length && !(this.filter.search && this.filter.search.length)
        },

        noFound() {
            return !this.modems.length && this.filter.search && this.filter.search.length
        }
    },

    methods: {
        search: debounce(function (e) {
            this.applyFilter({ page: 1, search: e.target.value })
        }, 600),

        async submit() {
            const isValid = await this.$refs.obs.validate()

            if (!isValid) {
                return
            }

            let done = await store.dispatch('modemsChallenges/store', this.form)

            if (done) {
                this.form.identity = ''
                this.$refs.obs.reset()
                toastSuccess('Заявка зарегистрирована')
                this.isFormVisible = false
            } else {
                mixinApiErrors(this.$refs.obs, this.$store.state.modemsChallenges.error)
            }
        },

        showHelp() {
            this.$nextTick(_ => (
                this.$refs.help.show()
            ))
        },

        async deleteModem(modemId) {
            const isConfirm = await confirm('Вы уверены, что хотите удалить?')

            if (isConfirm) {
                let done = await this.$store.dispatch('modems/delete', modemId)
                done ? toastSuccess('Удалено') : toastError('Ошибка')
            }
        },

        async deleteChallenge(challengeId) {
            const isConfirm = await confirm('Вы уверены, что хотите удалить?')

            if (isConfirm) {
                let done = await this.$store.dispatch('modemsChallenges/delete', challengeId)
                done ? toastSuccess('Удалено') : toastError('Ошибка')
            }
        },

        getKBLink(key) {
            return KBLinksService.get(key)
        }
    },

    async beforeRouteEnter(to, from, next) {
        await Promise.all([
            store.dispatch('modems/fetchAll', to.query),
            store.dispatch('modemsChallenges/fetchAll')
        ])

        next()
    },

    async beforeRouteUpdate(to, from, next) {
        await Promise.all([
            store.dispatch('modems/fetchAll', to.query)
        ])

        next()
    }
}
</script>
